var _mask, _g, _mask2, _g2, _path, _mask3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageLivelist = function SvgMypageLivelist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-livelist_svg__a",
    width: 14,
    height: 19,
    x: 7,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.5 4.5h12.75v18H7.5z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mypage-livelist_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD167",
    fillRule: "evenodd",
    d: "M20.25 4.5H7.5v12a3 3 0 0 0 3 3 3 3 0 0 0 3 3h6.75z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-livelist_svg__b",
    width: 15,
    height: 15,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 1.5h13.591v13.592H3.75z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mypage-livelist_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540E",
    fillRule: "evenodd",
    d: "M10.546 1.5A6.804 6.804 0 0 0 3.75 8.296a6.804 6.804 0 0 0 6.796 6.796h5.202v-2.435a6.78 6.78 0 0 0 1.593-4.361A6.804 6.804 0 0 0 10.545 1.5",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.353 9.348v.63H6.421v-3.34h.658v2.71z",
    clipRule: "evenodd"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mypage-livelist_svg__c",
    width: 18,
    height: 22,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 22.5h16.5v-21H3.75z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#mypage-livelist_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.699 9.978h.614V7.592h-.615zm-.072-3.05c0-.205.171-.381.377-.381.21 0 .382.176.382.381a.38.38 0 0 1-.382.377.38.38 0 0 1-.377-.377M12.125 7.592l-.906 2.386h-.702L9.61 7.592h.677l.577 1.67.583-1.67zM14.055 8.56a.58.58 0 0 0-.592-.482c-.33 0-.553.177-.625.482zm-.534.926c.238 0 .429-.1.534-.238l.496.286c-.225.324-.582.51-1.04.51-.802 0-1.308-.548-1.308-1.26 0-.71.51-1.26 1.26-1.26.707 0 1.208.56 1.208 1.26 0 .091-.01.172-.024.254h-1.8c.086.315.35.448.674.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF540E",
    d: "M10.9 19.074H9.49c-.407 0-.814-.156-1.125-.466l3 3a1.59 1.59 0 0 1-.466-1.125z"
  }))));
};
export default SvgMypageLivelist;